/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SystemHintsForStbGroupsResponse
 */
export interface SystemHintsForStbGroupsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SystemHintsForStbGroupsResponse
     */
    addBpProfiles: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SystemHintsForStbGroupsResponse
     */
    enableDeploymentModes: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SystemHintsForStbGroupsResponse
     */
    enableIpGroup?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SystemHintsForStbGroupsResponse
     */
    enableQuota?: boolean | null;
}

export function SystemHintsForStbGroupsResponseFromJSON(json: any): SystemHintsForStbGroupsResponse {
    return SystemHintsForStbGroupsResponseFromJSONTyped(json, false);
}

export function SystemHintsForStbGroupsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemHintsForStbGroupsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'addBpProfiles': json['addBpProfiles'],
        'enableDeploymentModes': json['enableDeploymentModes'],
        'enableIpGroup': !exists(json, 'enableIpGroup') ? undefined : json['enableIpGroup'],
        'enableQuota': !exists(json, 'enableQuota') ? undefined : json['enableQuota'],
    };
}

export function SystemHintsForStbGroupsResponseToJSON(value?: SystemHintsForStbGroupsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'addBpProfiles': value.addBpProfiles,
        'enableDeploymentModes': value.enableDeploymentModes,
        'enableIpGroup': value.enableIpGroup,
        'enableQuota': value.enableQuota,
    };
}

